import CustomIcon from "../../../core/CustomIcon/CustomIcon";
import { useState } from "react";
import classnames from "classnames";
import classes from "../Banner.module.scss";

function getFirstAlphabet(phrase) {
  const alpha = phrase.charAt(0);
  return alpha;
}

const SimpleBanner = ({
  image,
  title,
  description,
  className,
  clickHandler = () => {
    console.error("Provide the clickHandler property");
  },
}) => {
  const [isHover, setIsHover] = useState(false);

  const handleMouseEnter = () => {
    setIsHover(true);
  };
  const handleMouseLeave = () => {
    setIsHover(false);
  };
  const style = {
    container: {
      padding: 16,
      backgroundColor: isHover ? "#E2E8F0" : "#F1F5F9",
      display: "flex",
      flexDirection: "column",
      gap: 10,
      boxSizing: "border-box",
      height: "100%",
      cursor: "pointer",
    },
    image: {
      position: "relative",
      backgroundColor: "#FFFFFF",
      borderRadius: "100px",
      width: 56,
      height: 56,
    },
  };
  return (
    <div
      style={style.container}
      className={className}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={clickHandler}
    >
      <div style={style.image}>
        {image ? (
          <CustomIcon
            src={image}
            style={{
              backgroundColor: "#FFFFFF",
              borderRadius: "100px",
            }}
            className={classnames("center")}
            iconHeight={32}
            iconWidth={32}
          />
        ) : (
          <div className={classnames("center", classes.firstLetter)}>
            {getFirstAlphabet(title)}
          </div>
        )}
      </div>
      <div className={classes.title}>{title}</div>
      <div className={classes.description}>{description}</div>
    </div>
  );
};

export default SimpleBanner;
